// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const QrCode: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="-1 -1 28 28"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M12.278 5.056v7.222H5.056V5.056h7.222zM10.833 6.5H6.5v4.333h4.333V6.5zM8.667 0v2.889H2.889v5.778H0V0h8.667zM2.889 17.333v5.779h5.778v2.887H0v-8.666h2.889zm9.389-3.61v7.221H5.056v-7.222h7.222zm-1.445 1.444H6.5V19.5h4.333v-4.333zM20.944 5.056v7.222h-7.222V5.056h7.222zM19.5 6.5h-4.333v4.333H19.5V6.5zM26 0v8.667h-2.888V2.889h-5.78V0H26zm0 17.333v8.666h-8.668v-2.887h5.78v-5.78H26zm-5.048-3.61v7.221h-7.223v-7.222h7.223z"
            />
        </svg>
    );
};

export default React.memo(QrCode);
